"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIZARD_TRACKING_EVENTS = exports.CHATBOT_TRACKING_EVENTS = void 0;
const CHATBOT_TRACKING_EVENTS = exports.CHATBOT_TRACKING_EVENTS = [{
  value: 'loaded',
  label: 'Chat loaded'
}, {
  value: 'welcome_message',
  label: 'Welcome message clicked'
}, {
  value: 'welcome_message_closed',
  label: 'Welcome message closed'
}, {
  value: 'clicked',
  label: 'Chat icon clicked'
}, {
  value: 'closed',
  label: 'Chat closed'
}, {
  value: 'started',
  label: 'Started'
}, {
  value: 'restart',
  label: 'Restarted'
}, {
  value: 'url_button',
  label: 'URL button clicked'
}, {
  value: 'product_button',
  label: 'Recommended product clicked'
}, {
  value: 'products',
  label: 'Completed'
}, {
  value: 'add_to_cart',
  label: 'Added to cart'
}, {
  value: 'user_attribute_set',
  label: 'User attribute was set'
}];
const WIZARD_TRACKING_EVENTS = exports.WIZARD_TRACKING_EVENTS = [{
  value: 'loaded',
  label: 'Page loaded'
}, {
  value: 'started',
  label: 'Started'
}, {
  value: 'restart',
  label: 'Restarted'
}, {
  value: 'product_button',
  label: 'Recommended product clicked'
}, {
  value: 'products',
  label: 'Completed'
}, {
  value: 'add_to_cart',
  label: 'Added to cart'
}];